// ./src/config/constants.ts
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_DROPDOWN_PAGE_SIZE = 100;
export const DEFAULT_TIME_FORMAT = "h:mm A";
export const IS_PRODUCTION = import.meta.env.VITE_ENVIRONMENT === "production";
// Empty UUID constant for identifying system layouts
export const SYSTEM_ACCOUNT_ID = "00000000-0000-0000-0000-000000000000";

export const DEFAULT_CURRENCY = "USD";

export const SIGNIN_PAGE = '/account/signin';
export const SIGNUP_PAGE = '/account/signup';